import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

import {
    FETCH_CONSULTANTS_REQUEST,
    fetchConsultantsSuccess,
    fetchConsultantsFail,
    createConsultantSuccess,
    createConsultantFail,
    updateConsultantSuccess,
    updateConsultantFail,
    deleteConsultantSuccess,
    deleteConsultantFail,
    setConsultantsLoading,
} from "../actions/consultantsActions";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchConsultantsSaga() {
    const url = `${API_BASE_URL}/api/consultants`;
    yield put(setConsultantsLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid: getUid(), token: getToken() });
        yield put(fetchConsultantsSuccess(resp.data));
    } catch (e) {
        yield put(fetchConsultantsFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setConsultantsLoading(false));
    }
}

export function* createConsultantSaga(action) {
    const url = `${API_BASE_URL}/api/consultants`;
    yield put(setConsultantsLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: action.payload, uid: getUid(), token: getToken() });
        yield put(createConsultantSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Consultant ajouté", timer: 1400, showConfirmButton: false });
        yield put({ type: FETCH_CONSULTANTS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout consultant";
        yield put(createConsultantFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setConsultantsLoading(false));
    }
}

export function* updateConsultantSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/consultants/${id}`;
    yield put(setConsultantsLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: payload, uid: getUid(), token: getToken() });
        yield put(updateConsultantSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Consultant modifié", timer: 1400, showConfirmButton: false });
        yield put({ type: FETCH_CONSULTANTS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification consultant";
        yield put(updateConsultantFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setConsultantsLoading(false));
    }
}

export function* deleteConsultantSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/consultants/${id}`;
    yield put(setConsultantsLoading(true));
    try {
        yield call(deleteRequest, { url, uid: getUid(), token: getToken() });
        yield put(deleteConsultantSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", text: "Consultant supprimé", timer: 1400, showConfirmButton: false });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression consultant";
        yield put(deleteConsultantFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setConsultantsLoading(false));
    }
}
